import {
	SET_DASHBOARD,
	DELETE_DASHBOARD,
	ADD_DASHBOARD,
	UPDATE_DASHBOARD
} from "../../actions/DashboardDesigner/actionContants";

const dashboards = (state = [], action) => {
	switch (action.type) {
		case SET_DASHBOARD:
			return action.data;
		case DELETE_DASHBOARD:
			var { dashboardId } = action;
			return state.filter(obj => obj.id != dashboardId);
		case ADD_DASHBOARD:
			return [...state, action.data];
		case UPDATE_DASHBOARD:
			let tempDbState = state.map(obj => {
				if (obj.id === action.data.id) return action.data;
				else return obj;
			});
			tempDbState = _.orderBy(tempDbState, ["sortOrder"], ["asc"]);
			return tempDbState;
		case "SET_DASHBOARDS":
			return action.payload;
		default:
			return state;
	}
};

export default dashboards;
